export default {
  'requiredFields': {
    'career': [
      'RequestMessage',
      'RequestTopic'
    ]
  }
}
